import { WsAudioGeneradoPorPacientePayloadSchema, WsIaWebxrSchema } from '@alter/types';
import type { z } from 'zod';

/**
 * Transformaciones del borde. Es el **único** lugar del cliente donde el
 * wire cambia de forma al entrar o salir; el resto del código no ve las
 * grafías del wire que se renombran acá.
 */

/**
 * `ia` con remapeo `expresion_vr → expresion_avatar`. El nombre del wire
 * arrastra historia del cliente Unity VR; el campo describe la expresión
 * del avatar en cualquier cliente. `expresion_vr` desaparece del objeto.
 */
export const WsIaRemappedSchema = WsIaWebxrSchema.transform(({ expresion_vr, ...rest }) => ({
  ...rest,
  expresion_avatar: expresion_vr,
}));
export type WsIaRemapped = z.infer<typeof WsIaRemappedSchema>;

/**
 * `audio.generado_por_paciente` tal como `WebSocketClient` lo entrega al
 * caller: envelope de JC §3.3 con `ia` remapeado. `behavioral_cues` y todo
 * campo no declarado ya se descartaron en el schema del wire.
 */
export const WsAudioGeneradoPorPacienteRemappedSchema =
  WsAudioGeneradoPorPacientePayloadSchema.extend({
    ia: WsIaRemappedSchema,
  });
export type WsAudioGeneradoPorPacienteRemapped = z.infer<
  typeof WsAudioGeneradoPorPacienteRemappedSchema
>;

/**
 * Modalidad para el evento `conectar`. La decide el servidor (AX-12): el
 * cliente devuelve **el mismo valor** que recibió del REST, solo en
 * minúsculas, porque `conectar` las exige (`text_to_speech`, JC §0.3) y el
 * REST la manda en MAYÚSCULAS (`TEXT_TO_SPEECH`, verificado contra MVP el
 * 2026-09-19). No inventa ni mapea valores: solo cambia el casing.
 *
 * Hueco del contrato: JC §1 muestra minúsculas en la respuesta de
 * `iniciar`. Si el servidor se alinea, esta función queda como no-op.
 */
export function modalidadParaConectar(modalidadDelServidor: string): string {
  return modalidadDelServidor.toLowerCase();
}
